import { useSharedState } from '@trello/shared-state';

import type { LocationState } from './locationState';
import { locationState } from './locationState';

export function useLocation(): LocationState {
  const [location] = useSharedState(locationState);
  return location;
}
